import { useNavigate } from "@tanstack/react-router";
import { GOAL_OPTIONS } from "creso-core/constants";
import { Client } from "creso-core/types";
import { ChevronDown } from "lucide-react";
import {
  buttonVariants,
  cn,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "web-design-system";

export function CreateGoal({
  client,
  label,
}: {
  client: Client;
  label?: string;
}) {
  const navigate = useNavigate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(buttonVariants({ variant: "outline" }))}
      >
        {label ?? "Add goal"}
        <ChevronDown className="size-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {GOAL_OPTIONS.map((g) => (
          <DropdownMenuItem
            onClick={() =>
              navigate({
                to: ".",
                search: {
                  client_id: client.id,
                  modal: "goals",
                  goal_type: g.value,
                },
                replace: true,
              })
            }
            key={g.value}
          >
            {g.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
